import { pando3D } from './setup';

export const LEVEL = {

  showAll: () => {
    pando3D.materialScenes.forEach((scene, index) => {
      pando3D.materialScenes[index].line.visible = true;
      pando3D.materialScenes[index].material.forEach((face) => {
        face.visible = true;
      });
    });
  },

  showUntil: (showIndex) => {
    LEVEL.showAll();
    pando3D.materialScenes.forEach((scene, index) => {
      if (showIndex < index + 1) {
        pando3D.materialScenes[index].line.visible = false;
        pando3D.materialScenes[index].material.forEach((face) => {
          face.visible = false;
        });
      }
    });
  },

  showConsignee: (consignee) => {
    LEVEL.showAll();
    if(!(consignee.indexOf('All') !== -1)) {
      pando3D.materialScenes.forEach((scene, index) => {
        if (consignee !== scene.ref_id) {
          pando3D.materialScenes[index].line.visible = false;
          pando3D.materialScenes[index].material.forEach((face) => {
            face.visible = false;
          });
        }
      });
    }
  },

};

export default LEVEL;